import { dec, div, mul, type Decimal } from '../core/decimal.ts';

/** SafeWithdrawal.defaultRatePercent: the "4% rule". */
export const DEFAULT_SAFE_WITHDRAWAL_RATE_PERCENT = dec(4);

/** SafeWithdrawal.monthlyIncome: balance × (rate/100) / 12. */
export const safeWithdrawalMonthlyIncome = (
  balance: Decimal,
  ratePercent: Decimal = DEFAULT_SAFE_WITHDRAWAL_RATE_PERCENT,
): Decimal => div(mul(balance, div(ratePercent, dec(100))), dec(12));
